import React from 'react';

const IconCheckmark = () => {
  return (
    <svg
      width="106"
      height="106"
      viewBox="0 0 106 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        d="M101.661 37.7C98.0545 14.0141 80.716 2.811 53 3.00241C25.284 2.811 7.94939 14.0141 4.3385 37.7C3.4669 43.4098 3 48.2477 3 53C3 57.7269 3.4669 62.5852 4.3385 68.3C7.9455 91.9859 25.284 103.189 53 102.998C80.716 103.189 98.0506 91.9859 101.661 68.3C102.533 62.5902 103 57.7523 103 53C103 48.268 102.533 43.4098 101.661 37.7Z"
        stroke="#5268FF"
        strokeWidth="6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.7678 55.2322C29.7915 56.2085 29.7915 57.7915 30.7678 58.7678L42.7886 70.7886C43.7649 71.7649 45.3478 71.7649 46.3241 70.7886L76.7297 40.383C77.706 39.4067 77.706 37.8238 76.7297 36.8475C75.7534 35.8711 74.1705 35.8711 73.1942 36.8475L44.5563 65.4853L34.3033 55.2322C33.327 54.2559 31.7441 54.2559 30.7678 55.2322Z"
        fill="#5268FF"
      />
    </svg>
  );
};

export default IconCheckmark;
